(function(){
  var THRESHOLD = 100;
  // Tiers for the progress bar (dollars). Edit thresholds/labels here.
  // label    = short text shown in the bubble under the node
  // msgLabel = optional longer text used only in the top status message
  var TIERS = [
    { threshold: 100, label: 'Free Ship', msgLabel: 'free shipping' },
    { threshold: 150, label: '$20 Off' },
    { threshold: 280, label: '$35 Off' }
  ];
  // node positions across the track (%)
  var START = 18, END = 82;
  function nodePct(i){ return START + (i / (TIERS.length - 1)) * (END - START); }

  // Edit these labels to match your brand
  var BADGES = [
    { icon: 'heart',  label: '4,566 Happy<br>Customers' },
    { icon: 'return', label: 'Hassle-Free<br>Returns' },
    { icon: 'lock',   label: 'Secure<br>Payment' }
  ];
  var lastSub = null;
  var lastHasItems = null;
  var injecting = false;

  function fmt(d){ return '$' + Math.round(d).toLocaleString(); }

  // map a dollar subtotal onto the node-spaced track
  function subToPct(sub){
    var max = TIERS[TIERS.length - 1].threshold;
    if(sub <= 0) return 0;
    if(sub >= max) return 100;
    if(sub < TIERS[0].threshold){
      return (sub / TIERS[0].threshold) * nodePct(0);
    }
    for(var i = 0; i < TIERS.length - 1; i++){
      var lo = TIERS[i].threshold, hi = TIERS[i + 1].threshold;
      var loPct = nodePct(i), hiPct = nodePct(i + 1);
      if(sub < hi){
        var frac = (sub - lo) / (hi - lo);
        return loPct + frac * (hiPct - loPct);
      }
    }
    return 100;
  }

  function build(sub){
    var pct = subToPct(sub);
    var max = TIERS[TIERS.length - 1].threshold;
    var unlocked = sub >= max;

    // top status message: next unreached tier, or all-done
    var next = null;
    for(var i = 0; i < TIERS.length; i++){
      if(sub < TIERS[i].threshold){ next = TIERS[i]; break; }
    }
    var primary, subtitle;
    if(next){
      var msgLabel = next.msgLabel || next.label;
      primary = 'Spend $' + Math.round(next.threshold - sub) + ' more for ' + msgLabel;
      // show the metro-areas note only while the free-shipping tier is the goal
      subtitle = (next.threshold === TIERS[0].threshold) ? '(Selected Metro Areas)' : '&nbsp;';
    } else {
      primary = 'You\u2019ve unlocked all rewards';
      subtitle = '&nbsp;';
    }

    // nodes + labels
    var nodes = '', labels = '';
    TIERS.forEach(function(t, i){
      var p = nodePct(i);
      var reached = sub >= t.threshold;
      nodes += '<div class="cartbar-node' + (reached ? ' on' : '') + '" style="left:' + p + '%"></div>';
      var cls = 'cartbar-label';
      if(i === 0) cls += ' cartbar-label--first';
      if(i === TIERS.length - 1) cls += ' cartbar-label--last';
      labels += '<div class="' + cls + '" style="left:' + p + '%">' + fmt(t.threshold) + ' | ' + t.label + '</div>';
    });

    return '<div class="cartbar' + (unlocked ? ' on' : '') + '" id="cartbar">'
      + '<div class="cartbar-status">' + primary + '</div>'
      + '<div class="cartbar-subtitle">' + subtitle + '</div>'
      + '<div class="cartbar-bar">'
      + '<div class="cartbar-fill" style="width:' + pct + '%"></div>'
      + '<div class="cartbar-nodes">' + nodes + '</div>'
      + '</div>'
      + '<div class="cartbar-labels">' + labels + '</div>'
      + '</div>';
  }

  function findDrawer(){
    return document.querySelector('cart-drawer')
      || document.querySelector('#cart-drawer')
      || document.querySelector('.cart-drawer');
  }

  var ICONS = {
    heart:  '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    return: '<svg viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 9 8 9"/></svg>',
    lock:   '<svg viewBox="0 0 24 24"><rect x="4" y="11" width="16" height="11" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>'
  };

  function buildBadges(){
    var inner = BADGES.map(function(b){
      return '<div class="cartbadge">'
        + (ICONS[b.icon] || '')
        + '<div class="cartbadge-label">' + b.label + '</div>'
        + '</div>';
    }).join('');
    return '<div class="cartbadges" id="cartbadges">' + inner + '</div>';
  }

  function injectBadges(){
    var d = findDrawer();
    if(!d) return;
    if(d.querySelector('#cartbadges')) return;
    var footer = d.querySelector('.cart-drawer__footer')
      || d.querySelector('[class*="cart-drawer__footer"]')
      || d.querySelector('form[class*="footer"]');
    if(footer){
      footer.insertAdjacentHTML('afterend', buildBadges());
    } else {
      d.insertAdjacentHTML('beforeend', buildBadges());
    }
  }

  function place(d, html){
    var existing = d.querySelector('#cartbar');
    if(existing){
      existing.outerHTML = html;
      return;
    }
    var heading = d.querySelector('p.h4')
      || d.querySelector('.h4')
      || d.querySelector('h2');
    if(heading){
      heading.insertAdjacentHTML('afterend', html);
    } else {
      d.insertAdjacentHTML('afterbegin', html);
    }
  }

  function inject(){
    if(injecting) return;
    var d = findDrawer();
    if(!d) return;
    var hasItems = !!(d.querySelector('line-item') || d.querySelector('[class*="line-item"]'));
    var existing = d.querySelector('#cartbar');
    var existingBadges = d.querySelector('#cartbadges');

    if(!hasItems){
      if(existing) existing.remove();
      if(existingBadges) existingBadges.remove();
      lastHasItems = false;
      lastSub = null;
      return;
    }

    injectBadges();
    injecting = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var sub = (cart.items_subtotal_price || 0) / 100;
        var d2 = findDrawer();
        if(!d2){ injecting = false; return; }
        var ex2 = d2.querySelector('#cartbar');
        if(ex2 && sub === lastSub && lastHasItems === true){
          injecting = false;
          return;
        }
        lastSub = sub;
        lastHasItems = true;
        place(d2, build(sub));
        injectBadges();
        injecting = false;
      })
      .catch(function(){ injecting = false; });
  }

  // PRIMARY trigger: cart fetch interception
  var origFetch = window.fetch;
  window.fetch = function(){
    var url = arguments[0];
    var promise = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      promise.then(function(){
        setTimeout(inject, 300);
      });
    }
    return promise;
  };

  // SECONDARY trigger: cart drawer open/close
  var drawerOpenObs = null;
  function watchDrawerOpen(){
    var d = findDrawer();
    if(!d || drawerOpenObs) return;
    drawerOpenObs = new MutationObserver(function(){
      requestAnimationFrame(inject);
    });
    drawerOpenObs.observe(d, {
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden', 'data-open']
    });
  }

  // TERTIARY trigger: items container child changes
  var itemsObs = null;
  function watchItemsContainer(){
    var d = findDrawer();
    if(!d || itemsObs) return;
    var items = d.querySelector('[class*="cart-drawer__items"]')
      || d.querySelector('[class*="items"]');
    if(!items) return;
    itemsObs = new MutationObserver(function(muts){
      for(var i = 0; i < muts.length; i++){
        var t = muts[i].target;
        if(t && (t.id === 'cartbar' || (t.closest && t.closest('#cartbar')))) continue;
        inject();
        return;
      }
    });
    itemsObs.observe(items, { childList: true });
  }

  function init(){
    watchDrawerOpen();
    watchItemsContainer();
    inject();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if(!findDrawer()){
    var attempts = 0;
    var retry = setInterval(function(){
      if(findDrawer() || attempts++ > 20){
        clearInterval(retry);
        if(findDrawer()) init();
      }
    }, 250);
  }
})();